export const STATES = {
  SIGN_IN: 'app.sign.in',
  SIGN_OUT: 'app.sign.out',
  DASHBOARD: 'app.dashboard',
  DASHBOARD_NEW_MOVE: 'app.dashboard.new-move',
  DASHBOARD_SIGNUP_COMPLETE: 'app.dashboard.signup-complete',
  ERROR: 'app.error',
  FORGOT_PASSWORD: 'app.forgot-password',
  FORGOT_PASSWORD_RESET: 'app.forgot-password.reset',
  GET_STARTED_1: 'app.get-started.1',
  GET_STARTED_2: 'app.get-started.2',
  PERSONALIZATION_SURVEY: 'app.personalization-survey',
  INVITE: 'app.invite',
  MOVES_NEW: 'app.account.moves.new',
  MOVES_SUMMARY: 'app.account.moves.summary',
  MOVES_VERIFY: 'app.account.moves.verify',
  NEXT_STEP: 'app.next-step',
  PRO_APP_SIGN_IN: 'pro-app-sign-in',
  PROFILE: 'app.account.profile',
  ROOT: '',
  STEP_AUTO_INSURANCE: 'app.steps.auto-insurance',
  STEP_BACKUP_GENERATOR: 'app.steps.backup-generator',
  STEP_CALIFORNIA_CARE: 'app.steps.california-care',
  STEP_CUSTOM_INFORMATION: 'app.steps.custom-information',
  STEP_DIY_MOVE: 'app.steps.diy-move',
  STEP_DMV: 'app.steps.dmv',
  STEP_DUKE_WARRANTY: 'app.steps.duke-warranty',
  STEP_FORWARD_MAIL: 'app.steps.forward-mail',
  STEP_FORWARD_MAIL_LIST: 'app.steps.forward-mail.list',
  STEP_FORWARD_MAIL_NEW: 'app.steps.forward-mail.new',
  STEP_FORWARD_MAIL_EDIT: 'app.steps.forward-mail.edit',
  STEP_FORWARD_MAIL_VERIFY: 'app.steps.forward-mail.verify',
  STEP_FORWARD_MAIL_MILITARY: 'app.steps.forward-mail.military',
  STEP_FORWARD_MAIL_PROMOTIONS: 'app.steps.forward-mail.promotions',
  STEP_HUDSON_INSURANCE: 'app.steps.hudson-insurance',
  STEP_INSURANCE: 'app.steps.insurance',
  STEP_INSURANCE_CONFIRM_MOVE: 'app.steps.insurance-confirm',
  STEP_MOVEIQ: 'app.steps.moveiq',
  STEP_MOVE_YOUR_STUFF: 'app.steps.move-your-stuff',
  STEP_MOVING_CENTER: 'app.steps.moving-center',
  STEP_MOVING_CENTER_FORM: 'app.steps.moving-center.form',
  STEP_UPDATE_ACCOUNTS: 'app.steps.update-accounts',
  STEP_UPDATE_ACCOUNTS_SEARCH: 'app.steps.update-accounts.search',
  STEP_UPDATE_ACCOUNTS_CONFIRM: 'app.steps.update-accounts.confirm',
  STEP_UPDATE_ACCOUNTS_VERIFY: 'app.steps.update-accounts.verify',
  STEP_RELOCATION_SPECIALISTS: 'app.steps.full-service-move',
  STEP_PACKING_SUPPLIES: 'app.steps.packing-supplies',
  STEP_SHARE_MOVE: 'app.steps.share-move',
  STEP_SHARE_MOVE_CUSTOMIZE: 'app.steps.share-move.customize',
  STEP_SHARE_MOVE_PREVIEW: 'app.steps.share-move.preview',
  STEP_HOME_SECURITY: 'app.steps.home-security',
  STEP_HOME_SERVICES: 'app.steps.home-services',
  STEP_HOME_SERVICES_APP: 'app.steps.home-services-app',
  STEP_INSURANCE_QUOTES: 'app.steps.insurance-quotes',
  STEP_INSURANCE_RETENTION: 'app.steps.insurance-retention',
  STEP_UTILITIES: 'app.steps.utilities',
  STEP_UTILITIES_PROVIDERS: 'app.steps.utilities_providers',
  STEP_UTILITIES_MARKET: 'app.steps.utilities_market',
  STEP_RED_CROSS: 'app.steps.red-cross',
  STEP_RECOMMENDED_PROVIDERS: 'app.steps.recommended-providers',
  STEP_RESIDENT_PORTAL: 'app.steps.resident-portal',
  STEP_OFFERS: 'app.steps.offers',
  STEP_PROMOTIONS: 'app.steps.promotions',
  STEP_RENTERS_INSURANCE: 'app.steps.renters-insurance',
  STEP_SMART_HOME_OWN: 'app.steps.smart-home-own',
  PUBLIC_SHARE: 'app.public-share',
  UNSUBSCRIBE: 'app.unsubscribe',
  VERIFY: 'app.verify',
  WELCOME: 'app.welcome',
  NEW_PRODUCT_INTRO: 'app.new-product-intro',
  PRODUCT_QUESTIONNAIRE: 'app.product-questionnnaire',
  INSURANCE_QUESTIONNAIRE: 'app.insurance-questionnnaire',
};
